import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "runPay-v-select-language-wrap" }
const _hoisted_2 = { class: "runPay-v-select-language-item-wrap" }
const _hoisted_3 = { class: "runPay-v-select-language-item-title" }

import {LanguageModel, useLocalizationStore} from "@/shared";
import {computed, onMounted, ref} from "vue";
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'change-language',
  setup(__props) {

const {getAllLang, getCurrentCulture} = storeToRefs(useLocalizationStore());
const {setCurrentCulture} = useLocalizationStore();

/** Список языков */
const cultures =ref<Array<LanguageModel>>(getAllLang.value);

/** Рефка для v-select */
const theSelect = ref();

/** Текущий язык */
const activeLang = ref("");

/** Инициализация текущего языка */
onMounted(() => {
  language.value = getCurrentCulture.value;
});

/** Текущий язык */
const language = computed({
  get: (): LanguageModel => {
    return cultures.value?.find((x) => activeLang.value == x.Key);
  },
  set: (lang: LanguageModel) => {
    activeLang.value = lang?.Key;
  },
});

const open = () => {
  theSelect.value.onClick();
};

/** Изменение языка */
const changeLang = (culture) => {
  setCurrentCulture(culture.Key);
  language.value = culture;
};

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_select, {
      ref_key: "theSelect",
      ref: theSelect,
      modelValue: language.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
        changeLang
      ],
      items: cultures.value,
      class: "runPay-v-select-language",
      "item-title": "Value",
      "item-value": "Key",
      "return-object": "",
      variant: "solo"
    }, {
      item: _withCtx(({ props, item }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _mergeProps({
            class: [{ activeItem: item.raw.Key == activeLang.value }, "runPay-v-select-language-item"]
          }, props), [
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.raw.Value), 1)
          ], 16)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "items"])
  ]))
}
}

})